import React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import classnames from 'classnames';
import { Container } from 'typescript-ioc';
import DefaultButton from '../../../global/default-button/default-button';
import { IAccountDetailsDTO } from '../../../../api/accounts.dao';
import { Link } from '../../../../infrastructure/components/router-extensions';
import { Routes } from '../../../../routes-table';
import './account-list-item.scss';
import { IRouter } from '../../../../infrastructure/router';
import Text from '../../../global/text/text';

interface IAccountListItem extends IAccountDetailsDTO {
    editAccount: (accountId: number, intl: IntlShape) => void;
    isSelected: boolean;
    intl: IntlShape;
    withEdit: boolean;
}

const AccountListItem = injectIntl((props: IAccountListItem) => {
    const { accountId, name, editAccount, isSelected, intl, withEdit } = props;
    const routingService = Container.get(IRouter);

    const accountRouteParams = {
        accountId: accountId.toString(10),
    };

    const handleEventsClick = () => {
        routingService.navigate(Routes.EventsList, accountRouteParams);
    };

    const cellEffectClasses = classnames({
        'active': isSelected,
        'hoverable': !isSelected,
    });

    return (
        <tr data-account-id={accountId} className='account-list-item' onDoubleClick={handleEventsClick}>
            <td className={classnames(cellEffectClasses)}>
                <div className='name-column'>
                    <Text className='name-column__text' message={name} withEllipsis />
                    { withEdit && (
                        <DefaultButton
                            data-testid='edit-button'
                            modifier={['slim', 'link']}
                            className='visible-while-hovered'
                            text={
                                <FormattedMessage
                                    id='oe.common.editButton'
                                    description='Button text'
                                    defaultMessage='Edit'
                                />
                            }
                            onClick={() => { editAccount(accountId, intl); }}

                        />
                    )}
                </div>
            </td>
            <td className={classnames(cellEffectClasses, 'align-right')}>
                <Link className='visible-while-hovered' routeEnum={Routes.EventsList} routeParams={accountRouteParams}>
                    <DefaultButton
                        modifier='slim'
                        text={
                            <FormattedMessage
                                id='oe.events.eventsButton'
                                description='Events Button on Accounts'
                                defaultMessage='Events'

                            />
                        }
                    />
                </Link>
            </td>
        </tr>
    );
});

export { AccountListItem };
